module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/videographers-tile-bb6347a28f8f9f54e8efbc58f6b1d7e6.jpg";